module.exports = __webpack_public_path__ + "img/facebook.4329e9d8.png";